import React, { useEffect } from 'react';
import { Href, usePathname, useRouter } from 'expo-router';

import { useSetAccessToken } from '@/client/jwt';
import { useSentryUserContext } from '@/hooks/use-sentry-user-context';

type AuthProviderProps = {
  children: React.ReactNode;
};

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const pathname = usePathname();
  const router = useRouter();
  const setAccessToken = useSetAccessToken();

  // Track user context in Sentry
  useSentryUserContext();

  useEffect(() => {
    const handleAccessToken = async () => {
      // Only proceed if we have a search string
      if (!window.location.search) {
        return;
      }

      const params = new URLSearchParams(window.location.search);
      const accessToken = params.get('accessToken');

      if (accessToken) {
        setAccessToken(accessToken);
        const targetPath = pathname?.split('?')[0] || '/';
        router.replace(targetPath as Href);
      }
    };

    handleAccessToken();
  }, [pathname, router, setAccessToken]);

  return <>{children}</>;
};
